import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    debug: true,
    detection: {
      order: ['navigator', 'querystring', 'cookie', 'localStorage', 'sessionStorage', 'htmlTag', 'path', 'subdomain'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
      cookieExpirationDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365), // 1 year
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      es: {
        translation: {
          // Contenido en español
          "common": {
            "cancel": "Cancelar",
            "next": "Siguiente",
            "back": "Atrás",
            "submit": "Enviar",
            "close": "Cerrar",
            "notSpecified": "No especificado",
            "loading": "Cargando...",
            "home": "Inicio",
            "logout": "Cerrar sesión"
          },
          "header": {
            "searchGyms": "Buscar gimnasios",
            "business": "Empresas",
            "individual": "Particulares",
            "partners": "Partners",
            "plansAndPrices": "Planes y Precios",
            "register": "Registrarse",
            "login": "Iniciar Sesión",
            "language": "Idioma",
            "cities": {
              "title": "Ciudad",
              "barcelona": "Barcelona",
              "santiago": "Santiago de Chile",
              "caracas": "Caracas"
            }
          },
          "auth": {
            "client": "Cliente",
            "business": "Empresa",
            "partner": "Partner",
            "accountType": "Tipo de cuenta",
            "companyName": "Nombre de la empresa", 
            "gymName": "Nombre del gimnasio",
            "firstName": "Nombre",
            "lastName": "Apellido",
            "email": "Email",
            "password": "Contraseña",
            "confirmPassword": "Confirmar contraseña",
            "forgotPassword": "¿Olvidaste tu contraseña?",
            "continueWith": "O continúa con",
            "redirectInfo": "Si eres partner, te dirigiremos a tu panel de gestión; si representas una empresa, accederás al panel empresarial; y si eres cliente, te llevaremos a tu perfil personal.",
            "acceptTerms": "Acepto los ",
            "terms": "Términos y Condiciones",
            "acceptPrivacy": "Acepto la ",
            "privacy": "Política de Privacidad",
            "acceptMarketing": "Acepto recibir información comercial y promociones de TuttoGym",
            "requiredField": " *",
            "termsRequired": "Debes aceptar los términos y la política de privacidad para registrarte",
            "login": {
              "success": "Login exitoso"
            },
            "loggingOut": "Cerrando sesión...",
            "errors": {
              "emailExists": "Este email ya está registrado.",
              "invalidCredentials": "Email o contraseña inválidos.",
              "general": "Ocurrió un error. Por favor intenta nuevamente.",
              "emailRegisteredAsCustomer": "Este email ya está registrado como cliente",
              "emailRegisteredAsCompany": "Este email ya está registrado como empresa",
              "emailRegisteredAsPartner": "Este email ya está registrado como partner"
            },
            "validation": {
              "emailPasswordRequired": "Email y contraseña son requeridos",
              "passwordsDoNotMatch": "Las contraseñas no coinciden",
              "nameRequired": "Nombre y apellido son requeridos",
              "companyNameRequired": "El nombre de la empresa es requerido",
              "partnerNameRequired": "El nombre del socio es requerido"
            },
            "register": {
              "success": "Registro exitoso",
              "successTitle": "¡Registro exitoso!",
              "successMessage": "Tu cuenta ha sido creada correctamente. Redirigiendo..."
            }
          },
          "hero": {
            "title": "TuttoGym",
            "subtitle": "Todas tus actividades físicas en un solo lugar"
          },
          "benefits": {
            "allGyms": "Todos los gimnasios",
            "allActivities": "Todas las actividades",
            "registeredBusinesses": "Empresas inscritas",
            "title": "Beneficios de TuttoGym",
            "subtitle": "Todo lo que necesitas para mantenerte activo y saludable en un solo lugar",
            "descriptions": {
              "gyms": "Acceso a más de 1,000 gimnasios con una sola membresía.",
              "activities": "Disfruta de una amplia variedad de actividades: yoga, natación, pádel, crossfit y más.",
              "businesses": "Las empresas nos confían para ofrecer beneficios de bienestar a sus empleados."
            }
          },
          "search": {
            "title": "Encuentra tu gimnasio ideal",
            "activities": "Actividades",
            "plans": "Planes",
            "location": "Ciudad o código postal",
            "search": "Buscar",
            "searching": "Buscando...",
            "noResults": "No se encontraron gimnasios que coincidan con tu búsqueda."
          },
          "searchGyms": {
            "helmet": "Buscar gimnasios | TuttoGym",
            "title": "Encuentra tu gimnasio ideal",
            "subtitle": "Filtra por ciudad, actividades o código postal",
            "cityFilter": "Ciudad",
            "selectCity": "Selecciona una ciudad",
            "activitiesFilter": "Actividades",
            "postalCodeFilter": "Código postal",
            "enterPostalCode": "Introduce un código postal",
            "searchButton": "Buscar",
            "noResults": "No se encontraron gimnasios que coincidan con tu búsqueda",
            "tryDifferentSearch": "Intenta con otros filtros o una búsqueda diferente"
          },
          "activities": {
            "all": "Todas",
            "padel": "Pádel",
            "yoga": "Yoga",
            "swimming": "Natación",
            "crossfit": "Crossfit",
            "fitness": "Fitness",
            "pilates": "Pilates",
            "boxing": "Boxeo",
            "cycling": "Ciclismo",
            "spinning": "Spinning",
            "zumba": "Zumba",
            "gimnasio": "Gimnasio",
            "aquagym": "Aquagym",
            "entrenamiento_personal": "Entrenamiento Personal",
            "polideportivo": "Polideportivo",
            "artes_marciales": "Artes Marciales",
            "escalada": "Escalada"
          },
          "plans": {
            "bronze": "Bronze",
            "silver": "Silver",
            "gold": "Gold",
            "platinum": "Platinum",
            "diamond": "Diamond",
            "title": "Explora Nuestros Planes",
            "subtitle": "Elige el plan que mejor se adapte a tus necesidades y objetivos",
            "features": {
              "gyms": "Acceso a gimnasios",
              "activities": "Actividades incluidas",
              "schedule": "Horario",
              "guests": "Invitados gratis",
              "trainer": "Entrenador personal",
              "complete": "completo",
              "all": "todos",
              "unlimited": "ilimitados"
            },
            "monthly": "/mes",
            "choosePlan": "Elegir Plan",
            "mostPopular": "Más popular"
          },
          "footer": {
            "apps": "Aplicaciones",
            "social": "Redes Sociales",
            "privacy": "Privacidad",
            "cookies": "Cookies",
            "terms": "Términos",
            "security": "Seguridad"
          },
          "faq": {
            "title": "Preguntas Frecuentes",
            "subtitle": "Respuestas a las preguntas más frecuentes sobre TuttoGym",
            "questions": [
              {
                "question": "¿Cómo funciona TuttoGym?",
                "answer": "TuttoGym es una plataforma que te permite acceder a múltiples gimnasios y actividades con una sola membresía. Simplemente elige tu plan, regístrate y comienza a disfrutar de todos los gimnasios y actividades incluidas en tu membresía."
              },
              {
                "question": "¿Puedo cancelar mi suscripción en cualquier momento?",
                "answer": "Sí, puedes cancelar tu suscripción en cualquier momento. No hay contratos de permanencia. La cancelación será efectiva al final del período de facturación actual."
              },
              {
                "question": "¿Hay alguna tarifa de inscripción?",
                "answer": "No, no cobramos ninguna tarifa de inscripción. Solo pagas la cuota mensual del plan que elijas."
              },
              {
                "question": "¿Cuántas veces puedo visitar un mismo gimnasio?",
                "answer": "Puedes visitar cualquier gimnasio de la red una vez al día. Ten en cuenta que algunos gimnasios pueden establecer un límite máximo de visitas al mes. Esta información estará especificada en el perfil del gimnasio."
              },
              {
                "question": "¿Cómo reservo una actividad?",
                "answer": "Puedes reservar actividades directamente desde nuestra aplicación móvil o sitio web. Selecciona la actividad, el horario y el gimnasio, y confirma tu reserva con unos pocos clics."
              },
              {
                "question": "¿Qué pasa si no puedo asistir a una actividad reservada?",
                "answer": "Te pedimos que canceles tu reserva con al menos 2 horas de antelación para liberar el espacio para otros usuarios. Las cancelaciones frecuentes sin previo aviso pueden resultar en restricciones temporales para hacer reservas."
              }
            ]
          },
          "pages": {
            "business": {
              "benefits": [
                {
                  "title": "Mejora la salud y bienestar de tus empleados",
                  "description": "Ofrece acceso a más de 1,000 gimnasios y actividades para promover un estilo de vida saludable."
                },
                {
                  "title": "Reduce el absentismo laboral",
                  "description": "Los empleados activos tienen un 27% menos de días de baja por enfermedad."
                },
                {
                  "title": "Aumenta la productividad",
                  "description": "El ejercicio regular mejora la concentración y el rendimiento en el trabajo."
                },
                {
                  "title": "Atrae y retiene talento",
                  "description": "El 87% de los empleados considera los beneficios de bienestar al elegir un empleador."
                }
              ],
              "features": [
                "Portal de administración personalizado",
                "Informes de uso y participación",
                "Soporte dedicado para empresas",
                "Facturación centralizada",
                "Personalización de planes según necesidades",
                "Integración con sistemas de RRHH",
                "Comunicación interna de beneficios",
                "Eventos corporativos exclusivos"
              ],
              "cta": {
                "title": "¿Listo para mejorar el bienestar de tu equipo?",
                "subtitle": "Únete a más de 500 empresas que ya confían en TuttoGym para sus programas de bienestar corporativo.",
                "button": "Contactar con un asesor"
              },
              "requestForm": {
                "title": "Solicitar Información",
                "advisorTitle": "Contactar un Asesor",
                "steps": ["Email", "Empresa", "Presupuesto", "Información Adicional", "Confirmación"],
                "emailStep": {
                  "title": "Introduce tu email",
                  "emailLabel": "Correo electrónico",
                  "emailRequired": "El email es obligatorio",
                  "emailInvalid": "Formato de email inválido"
                },
                "companyStep": {
                  "title": "Información de la empresa",
                  "companyNameLabel": "Nombre de la empresa",
                  "companyNameRequired": "El nombre de la empresa es obligatorio",
                  "employeeSizeLabel": "Número de empleados",
                  "employeeSizeRequired": "Por favor seleccione el tamaño de la empresa",
                  "phoneLabel": "Teléfono (opcional)"
                },
                "quoteStep": {
                  "title": "Calculando tu presupuesto...",
                  "calculating": "Por favor espera mientras calculamos un presupuesto personalizado para tu empresa...",
                  "quoteTitle": "Tu Presupuesto Estimado",
                  "quoteDescription": "Este es un precio anual estimado basado en el tamaño de tu empresa.",
                  "downloadButton": "Descargar Presupuesto",
                  "downloadSuccess": "¡Presupuesto descargado!"
                },
                "additionalInfoStep": {
                  "title": "Información Adicional",
                  "subtitle": "¿Tienes alguna pregunta o requisito específico?",
                  "messageLabel": "Tu mensaje (opcional)"
                },
                "confirmationStep": {
                  "title": "¡Gracias!",
                  "infoMessage": "Hemos recibido tu solicitud de información. Nuestro equipo se pondrá en contacto contigo en breve con más detalles.",
                  "advisorMessage": "Alguien de ventas@tuttogym.com se pondrá en contacto contigo pronto."
                },
                "buttons": {
                  "back": "Atrás",
                  "next": "Siguiente",
                  "submit": "Enviar",
                  "close": "Cerrar"
                },
                "errors": {
                  "general": "Ocurrió un error al procesar tu solicitud. Por favor intenta nuevamente."
                }
              }
            },
            "individual": {
              "hero": {
                "title": "Your fitness journey starts here",
                "subtitle": "Access more than 1,000 gyms and activities with a single membership",
                "button": "Start now"
              },
              "benefits": [
                {
                  "title": "Freedom to choose",
                  "description": "Train wherever and whenever you want with access to more than 1,000 gyms."
                },
                {
                  "title": "Variety of activities",
                  "description": "From yoga to CrossFit, swimming to boxing - find what motivates you."
                },
                {
                  "title": "No commitments",
                  "description": "No long-term contracts. Cancel your membership whenever you want."
                },
                {
                  "title": "Affordable prices",
                  "description": "Plans starting at €29.99/month, much less than a traditional gym membership."
                }
              ],
              "features": {
                "title": "Why choose TuttoGym?",
                "subtitle": "The smart way to stay active",
                "items": [
                  "Access to more than 1,000 gyms",
                  "Book classes instantly",
                  "No registration fees",
                  "Bring friends with you",
                  "Personalized recommendations",
                  "24/7 customer support"
                ]
              },
              "testimonials": {
                "title": "What our members say",
                "items": [
                  {
                    "name": "Sarah Johnson",
                    "text": "TuttoGym has completely changed how I exercise. I love being able to try different activities and gyms depending on my mood and schedule."
                  },
                  {
                    "name": "Michael Rodriguez",
                    "text": "The flexibility is amazing. I travel a lot for work and can always find a gym nearby. It's like having a membership to every gym in the city!"
                  },
                  {
                    "name": "Emma Thompson",
                    "text": "I've discovered activities I never would have tried before. The variety keeps me motivated and I've never been in better shape."
                  }
                ]
              }
            },
            "partners": {
              "hero": {
                "title": "Grow your business with TuttoGym",
                "subtitle": "Join our network of gyms and fitness centers and reach thousands of new customers",
                "button": "Become a partner"
              },
              "benefits": [
                {
                  "title": "Increase your revenue",
                  "description": "Attract new customers and fill unused capacity without cannibalizing your existing membership base."
                },
                {
                  "title": "Zero risk",
                  "description": "No upfront costs or monthly fees. You only share revenue from the customers we bring to you."
                },
                {
                  "title": "Simple integration",
                  "description": "Our system integrates seamlessly with your existing management software and processes."
                },
                {
                  "title": "Full control",
                  "description": "You decide when TuttoGym members can visit your facility, maintaining control of your capacity."
                }
              ],
              "howItWorks": {
                "title": "How it works",
                "steps": [
                  {
                    "title": "Join our network",
                    "description": "Sign up as a TuttoGym partner and set up your profile with photos, amenities, and available activities."
                  },
                  {
                    "title": "Set your availability",
                    "description": "Define when TuttoGym members can visit your facility based on your capacity and peak hours."
                  },
                  {
                    "title": "Welcome new customers",
                    "description": "TuttoGym members check in using our app, and you verify their identity with a simple QR code scan."
                  },
                  {
                    "title": "Get paid",
                    "description": "Receive monthly payments for all TuttoGym visits to your facility, with detailed reporting and analytics."
                  }
                ]
              },
              "cta": {
                "title": "Ready to expand your customer base?",
                "subtitle": "Join over 1,000 fitness facilities already partnering with TuttoGym",
                "button": "Apply now"
              },
              "requestForm": {
                "title": "Request Information",
                "advisorTitle": "Contact an Advisor",
                "steps": ["Email", "Company", "Quote", "Additional Info", "Confirmation"],
                "emailStep": {
                  "title": "Enter your email",
                  "emailLabel": "Email",
                  "emailRequired": "Email is required",
                  "emailInvalid": "Invalid email format"
                },
                "companyStep": {
                  "title": "Company Information",
                  "companyNameLabel": "Gym Name",
                  "companyNameRequired": "Gym name is required",
                  "clientSizeLabel": "Number of Monthly Clients",
                  "clientSizeRequired": "Please select number of clients",
                  "avgPriceLabel": "Monthly Average Fee per Client",
                  "avgPriceRequired": "Please enter a valid average fee",
                  "phoneLabel": "Phone (optional)"
                },
                "quoteStep": {
                  "title": "Calculating your quote...",
                  "calculating": "Please wait while we calculate a personalized quote for your gym...",
                  "quoteTitle": "Your Estimated Quote",
                  "quoteDescription": "This is an estimated annual price based on your gym size.",
                  "downloadButton": "Download Quote",
                  "downloadSuccess": "Quote downloaded!"
                },
                "additionalInfoStep": {
                  "title": "Additional Information",
                  "subtitle": "Do you have any specific questions or requirements?",
                  "messageLabel": "Your message (optional)"
                },
                "confirmationStep": {
                  "title": "Thank You!",
                  "infoMessage": "We have received your partner request. Our team will contact you shortly with more details.",
                  "advisorMessage": "Someone from partners@tuttogym.com will contact you soon."
                },
                "buttons": {
                  "back": "Back",
                  "next": "Next",
                  "submit": "Submit",
                  "close": "Close"
                },
                "errors": {
                  "general": "Ocurrió un error al procesar tu solicitud. Por favor intenta nuevamente."
                }
              }
            },
            "plansAndPrices": {
              "title": "Planes y Precios",
              "subtitle": "Elige el plan que mejor se adapte a tus necesidades",
              "metaDescription": "Descubre nuestros planes y precios para particulares y empresas. Accede a miles de gimnasios y actividades con una sola membresía.",
              "tabs": {
                "individual": "Individual",
                "business": "Empresa"
              },
              "billing": {
                "monthly": "Mensual",
                "annual": "Anual",
                "saveText": "Ahorra 20%"
              },
              "features": {
                "access100": "Acceso a 100+ gimnasios",
                "access500": "Acceso a 500+ gimnasios",
                "access800": "Acceso a 800+ gimnasios",
                "access1000": "Acceso a 1000+ gimnasios",
                "activities3": "3 actividades incluidas",
                "activities5": "5 actividades incluidas",
                "activitiesAll": "Todas las actividades incluidas",
                "limitedHours": "Horas limitadas (8:00-16:00)",
                "fullHours": "Horas completas",
                "poolAccess": "Acceso a la piscina",
                "freeGuests": "Invitados gratis",
                "freeGuests1": "1 invitado gratis al mes",
                "freeGuests2": "2 invitados gratis al mes",
                "personalTrainer": "Entrenador personal",
                "personalTrainer1": "1 sesión con entrenador personal",
                "personalTrainer2": "2 sesiones con entrenador personal"
              },
              "business": {
                "perUser": "/ usuario / mes",
                "forUsers": "Para {min}-{max} usuarios",
                "forUsersUnlimited": "Para {min}-∞ usuarios",
                "customPrice": "Personalizado",
                "features": {
                  "access500": "Acceso a 500+ gimnasios",
                  "access800": "Acceso a 800+ gimnasios",
                  "access1000": "Acceso a 1000+ gimnasios",
                  "activities5": "5 actividades incluidas",
                  "activitiesAll": "Todas las actividades incluidas",
                  "adminPanel": "Panel de administración",
                  "advancedAdminPanel": "Panel de administración avanzada",
                  "customAdminPanel": "Panel de administración personalizado",
                  "basicReports": "Reportes básicos",
                  "detailedReports": "Reportes detallados",
                  "customReports": "Reportes personalizados",
                  "emailSupport": "Soporte de correo electrónico",
                  "prioritySupport": "Soporte prioritario",
                  "dedicatedManager": "Gestor de cuenta dedicado",
                  "corporateEvents": "Eventos corporativos",
                  "corporateEvents2": "2 eventos corporativos al año",
                  "corporateEventsUnlimited": "Eventos corporativos ilimitados"
                }
              },
              "buttons": {
                "choosePlan": "Elegir Plan",
                "contact": "Contactar"
              },
              "customPlan": {
                "title": "¿Necesita un plan personalizado?",
                "subtitle": "Si tiene necesidades específicas o está buscando una solución adaptada, póngase en contacto con nuestro equipo.",
                "button": "Contactar ventas"
              },
              "companyPayment": {
                "title": "¿Quieres que tu empresa pague el 25%, 50% o 100% de tu membresía?",
                "button": "Haz clic aquí"
              },
              "faq": {
                "title": "Preguntas frecuentes sobre planes y precios",
                "questions": [
                  {
                    "question": "¿Puedo cambiar de plan en cualquier momento?",
                    "answer": "Sí, puedes actualizar o cambiar tu plan en cualquier momento. Los cambios se aplicarán en tu próximo ciclo de facturación."
                  },
                  {
                    "question": "¿Hay algún compromiso de permanencia?",
                    "answer": "No, no hay compromiso de permanencia. Puedes cancelar tu suscripción en cualquier momento."
                  },
                  {
                    "question": "¿Qué métodos de pago aceptáis?",
                    "answer": "Aceptamos tarjetas de crédito/débito (Visa, Mastercard, American Express) y PayPal. Para planes empresariales, también ofrecemos transferencia bancaria."
                  },
                  {
                    "question": "¿Ofrecéis descuentos para estudiantes?",
                    "answer": "Sí, ofrecemos un 15% de descuento para estudiantes con identificación válida. Contacta con nuestro servicio de atención al cliente para más información."
                  }
                ]
              },
              "dialog": {
                "title": {
                  "step1": "Solicitar patrocinio de empresa",
                  "step2": "Información de contacto"
                },
                "steps": {
                  "company": "Información de empresa",
                  "contact": "Datos de contacto"
                },
                "labels": {
                  "company": "Nombre de la empresa",
                  "email": "Email de contacto de la empresa"
                },
                "success": "¡Tu solicitud ha sido enviada! Por favor, envía un correo a ventas@tuttogym.com con la información de la empresa."
              }
            }
          },
          "signup": {
            "title": "Comienza tu viaje fitness",
            "closeButton": "Cerrar",
            "backButton": "Atrás",
            "nextButton": "Siguiente",
            "submitButton": "Enviar",
            "processingButton": "Procesando...",
            "steps": {
              "personalInfo": "Información Personal",
              "email": "Email",
              "sports": "Deportes",
              "terms": "Términos y Políticas",
              "confirmation": "Confirmación"
            },
            "validation": {
              "firstNameRequired": "El nombre es requerido",
              "lastNameRequired": "El apellido es requerido",
              "emailRequired": "Email es requerido",
              "emailInvalid": "Formato de email inválido",
              "sportRequired": "Por favor selecciona al menos un deporte o especifica otros",
              "termsRequired": "Debes aceptar los términos y condiciones",
              "privacyRequired": "Debes aceptar la política de privacidad"
            },
            "errors": {
              "general": "Ocurrió un error al procesar tu solicitud. Por favor intenta nuevamente."
            },
            "personalInfo": {
              "title": "Introduce tus datos",
              "description": "Necesitamos esta información para crear tu cuenta personal.",
              "firstNameLabel": "Nombre",
              "lastNameLabel": "Apellido"
            },
            "email": {
              "title": "Introduce tu email",
              "description": "Te enviaremos información sobre nuestros servicios y cómo comenzar.",
              "label": "Correo electrónico"
            },
            "sports": {
              "title": "¿Qué deportes practicas?",
              "description": "Selecciona todos los que apliquen. Esto nos ayuda a recomendarte los mejores gimnasios.",
              "otherSportsLabel": "Otros deportes (separados por coma)",
              "otherSportsPlaceholder": "Ej. Escalada, Baile, Voleibol"
            },
            "terms": {
              "title": "Términos y Políticas",
              "description": "Por favor, revisa y acepta nuestros términos y políticas para continuar.",
              "accept": "Acepto los ",
              "name": "Términos y Condiciones",
              "acceptMarketing": "Acepto recibir información comercial y promociones de TuttoGym"
            },
            "confirmation": {
              "title": "¡Gracias!",
              "description": "Hemos recibido tu información. TuttoGym se lanzará el 7 de julio de 2025, y nos pondremos en contacto contigo antes del lanzamiento con oportunidades exclusivas de acceso anticipado.",
              "emailSent": "Un correo de confirmación ha sido enviado a"
            },
            "privacy": {
              "accept": "Acepto la ",
              "name": "Política de Privacidad"
            }
          },
          "legal": {
            "terms": "Términos y Condiciones",
            "privacy": "Política de Privacidad",
            "contactForQuestions": "Si tienes alguna pregunta sobre este documento, por favor contáctanos en",
            "lastUpdated": "Última actualización",
            "termsIntroduction": "Introducción",
            "termsIntroductionText": "Estos términos y condiciones regulan el uso del servicio ofrecido por TuttoGym en su sitio web, aplicación móvil y plataformas relacionadas. Al registrarte y utilizar nuestros servicios, aceptas estar sujeto a estos términos y condiciones, así como a nuestra Política de Privacidad.",
            "servicesDescription": "Descripción del servicio",
            "servicesDescriptionText": "TuttoGym ofrece una plataforma que permite a los usuarios acceder a múltiples gimnasios y actividades deportivas mediante una suscripción. Nuestro servicio incluye la gestión de reservas, acceso a diferentes instalaciones deportivas y actividades según el plan contratado.",
            "accountRegistration": "Registro de cuenta y responsabilidades",
            "accountRegistrationText": "Para utilizar nuestros servicios, debes registrarte y crear una cuenta. Al hacerlo, aceptas proporcionar información verdadera, precisa y completa. Eres responsable de mantener la confidencialidad de tu cuenta y contraseña, así como de todas las actividades que ocurran bajo tu cuenta.",
            "subscriptionTerms": "Términos de suscripción y pagos",
            "subscriptionTermsText": "TuttoGym ofrece diferentes planes de suscripción. Al contratar un plan, aceptas pagar las tarifas correspondientes. Los pagos son recurrentes y se realizarán de forma automática según el ciclo de facturación seleccionado. Puedes cancelar tu suscripción en cualquier momento, la cual será efectiva al final del período de facturación actual.",
            "useRestrictions": "Restricciones de uso",
            "useRestrictionsText": "El acceso a las instalaciones y actividades está sujeto a disponibilidad y a los términos específicos de cada gimnasio o centro. TuttoGym se reserva el derecho de restringir el acceso en caso de uso indebido o incumplimiento de las normas establecidas.",
            "intellectualProperty": "Propiedad intelectual",
            "intellectualPropertyText": "Todo el contenido presente en nuestro sitio web y aplicación, incluyendo textos, gráficos, logotipos, iconos, imágenes y software, es propiedad de TuttoGym o sus proveedores y está protegido por leyes de propiedad intelectual.",
            "liability": "Limitación de responsabilidad",
            "liabilityText": "TuttoGym no se hace responsable por lesiones o daños que puedan ocurrir durante la práctica de actividades deportivas. Los usuarios participan bajo su propio riesgo y deben seguir las instrucciones y normas de seguridad de cada instalación.",
            "termsModification": "Modificación de términos",
            "termsModificationText": "TuttoGym se reserva el derecho de modificar estos términos y condiciones en cualquier momento. Las modificaciones entrarán en vigor inmediatamente después de su publicación. El uso continuado de nuestros servicios después de cualquier cambio constituye tu aceptación de los nuevos términos.",
            "terminationOfService": "Terminación del servicio",
            "terminationOfServiceText": "TuttoGym se reserva el derecho de suspender o terminar tu cuenta y acceso a los servicios en caso de incumplimiento de estos términos y condiciones, uso fraudulento o cualquier actividad que pueda perjudicar a la plataforma o a otros usuarios.",
            "applicableLaw": "Ley aplicable",
            "applicableLawText": "Estos términos y condiciones se rigen por las leyes de España. Cualquier disputa relacionada con estos términos se resolverá en los tribunales competentes de Barcelona.",
            "privacyIntroduction": "Introducción",
            "privacyIntroductionText": "En TuttoGym nos tomamos muy en serio la privacidad de nuestros usuarios. Esta Política de Privacidad describe cómo recopilamos, utilizamos, procesamos y protegemos tu información personal cuando utilizas nuestros servicios, ya sea a través de nuestro sitio web, aplicación móvil u otras plataformas.",
            "dataCollection": "Información que recopilamos",
            "dataCollectionText": "Podemos recopilar la siguiente información personal:",
            "dataCollection1": "Información de registro: nombre, apellidos, dirección de correo electrónico, contraseña.",
            "dataCollection2": "Información de perfil: edad, género, intereses deportivos, foto de perfil (opcional).",
            "dataCollection3": "Datos de facturación: información de pago, historial de transacciones.",
            "dataCollection4": "Datos de uso: información sobre cómo utilizas nuestros servicios, gimnasios que visitas, actividades que reservas.",
            "dataCollection5": "Información técnica: dirección IP, tipo de navegador, dispositivo, sistema operativo.",
            "dataUse": "Cómo utilizamos tu información",
            "dataUseText": "Utilizamos la información recopilada para:",
            "dataUse1": "Proporcionar, mantener y mejorar nuestros servicios.",
            "dataUse2": "Procesar pagos y gestionar tu suscripción.",
            "dataUse3": "Personalizar tu experiencia y proporcionarte recomendaciones.",
            "dataUse4": "Comunicarnos contigo sobre actualizaciones, ofertas y eventos.",
            "dataUse5": "Detectar, prevenir y abordar problemas técnicos, fraudes o actividades ilegales.",
            "dataSharing": "Compartición de datos",
            "dataSharingText": "Podemos compartir tu información con:",
            "dataSharing1": "Gimnasios y centros deportivos asociados para validar tu acceso y reservas.",
            "dataSharing2": "Proveedores de servicios que nos ayudan a proporcionar nuestros servicios (procesamiento de pagos, análisis, marketing).",
            "dataSharing3": "Autoridades legales cuando sea requerido por la ley o para proteger nuestros derechos.",
            "dataSecurity": "Seguridad de los datos",
            "dataSecurityText": "Implementamos medidas de seguridad técnicas, administrativas y físicas diseñadas para proteger la información personal que recopilamos. Sin embargo, ningún sistema es completamente seguro, por lo que no podemos garantizar la seguridad absoluta de tu información.",
            "dataRetention": "Retención de datos",
            "dataRetentionText": "Conservamos tu información personal mientras mantengas una cuenta activa o según sea necesario para proporcionarte servicios. También podemos retener cierta información para cumplir con obligaciones legales, resolver disputas y hacer cumplir nuestros acuerdos.",
            "yourRights": "Tus derechos",
            "yourRightsText": "Dependiendo de tu ubicación, puedes tener ciertos derechos relacionados con tu información personal, incluyendo:",
            "yourRights1": "Acceder a tu información personal.",
            "yourRights2": "Corregir información inexacta.",
            "yourRights3": "Eliminar tu información en determinadas circunstancias.",
            "yourRights4": "Oponerte al procesamiento de tu información.",
            "yourRights5": "Retirar tu consentimiento en cualquier momento.",
            "cookies": "Cookies y tecnologías similares",
            "cookiesText": "Utilizamos cookies y tecnologías similares para mejorar tu experiencia, analizar el tráfico y personalizar el contenido. Puedes gestionar tus preferencias de cookies a través de la configuración de tu navegador.",
            "privacyChildren": "Privacidad de los niños",
            "privacyChildrenText": "Nuestros servicios no están dirigidos a personas menores de 16 años. No recopilamos a sabiendas información personal de niños menores de 16 años. Si descubrimos que hemos recopilado información personal de un niño menor de 16 años, eliminaremos esa información lo antes posible.",
            "privacyChanges": "Cambios en esta Política de Privacidad",
            "privacyChangesText": "Podemos actualizar nuestra Política de Privacidad de vez en cuando. Te notificaremos cualquier cambio publicando la nueva Política de Privacidad en esta página y, si los cambios son significativos, te proporcionaremos un aviso más prominente o te enviaremos una notificación por correo electrónico."
          },
          "dashboard": {
            "customer": {
              "title": "Panel de Cliente",
              "id": "ID de Cliente",
              "welcome": "Bienvenido",
              "welcomeText": "Este es tu panel personal de TuttoGym. Aquí puedes hacer seguimiento de tus actividades físicas, gestionar tus membresías y ver tu progreso.",
              "myFitnessCenters": "Mis Centros Deportivos",
              "myActivities": "Mis Actividades",
              "activitiesThisMonth": "Actividades Este Mes",
              "activeMemberships": "Membresías Activas"
            },
            "memberSince": "Miembro desde",
            "history": "Historial",
            "statistics": "Estadísticas",
            "tabs": {
              "dashboard": "Panel Principal",
              "activity": "Actividad",
              "settings": "Configuración"
            }
          }
        }
      },
      en: {
        translation: {
          // English content
          "common": {
            "cancel": "Cancel",
            "next": "Next",
            "back": "Back",
            "submit": "Submit",
            "close": "Close",
            "notSpecified": "Not specified",
            "loading": "Loading...",
            "home": "Home",
            "logout": "Logout"
          },
          "header": {
            "searchGyms": "Find gyms",
            "business": "Business",
            "individual": "Individuals",
            "partners": "Partners",
            "plansAndPrices": "Plans & Pricing",
            "register": "Register",
            "login": "Log in",
            "language": "Language",
            "cities": {
              "title": "City",
              "barcelona": "Barcelona",
              "santiago": "Santiago de Chile",
              "caracas": "Caracas"
            }
          },
          "auth": {
            "client": "Customer",
            "business": "Company",
            "partner": "Partner",
            "accountType": "Account type",
            "companyName": "Company name", 
            "gymName": "Gym name",
            "firstName": "First name",
            "lastName": "Last name",
            "email": "Email",
            "password": "Password",
            "confirmPassword": "Confirm password",
            "forgotPassword": "Forgot your password?",
            "continueWith": "Or continue with",
            "redirectInfo": "If you're a partner, we'll direct you to your management panel; if you represent a company, you'll access the business panel; and if you're a customer, we'll take you to your personal profile.",
            "acceptTerms": "I accept the ",
            "terms": "Terms and Conditions",
            "acceptPrivacy": "I accept the ",
            "privacy": "Privacy Policy",
            "acceptMarketing": "I agree to receive commercial information and promotions from TuttoGym",
            "requiredField": " *",
            "termsRequired": "You must accept the terms and privacy policy to register",
            "login": {
              "success": "Login successful"
            },
            "loggingOut": "Logging out...",
            "errors": {
              "emailExists": "This email is already registered.",
              "invalidCredentials": "Invalid email or password.",
              "general": "An error occurred. Please try again.",
              "emailRegisteredAsCustomer": "This email is already registered as a customer",
              "emailRegisteredAsCompany": "This email is already registered as a company",
              "emailRegisteredAsPartner": "This email is already registered as a partner"
            },
            "validation": {
              "emailPasswordRequired": "Email and password are required",
              "passwordsDoNotMatch": "Passwords do not match",
              "nameRequired": "First name and last name are required",
              "companyNameRequired": "Company name is required",
              "partnerNameRequired": "Partner name is required"
            },
            "register": {
              "success": "Registration successful",
              "successTitle": "Registration successful!",
              "successMessage": "Your account has been created successfully. Redirecting..."
            }
          },
          "hero": {
            "title": "TuttoGym",
            "subtitle": "All your physical activities in one place"
          },
          "benefits": {
            "allGyms": "All Gyms",
            "allActivities": "All Activities",
            "registeredBusinesses": "Registered Businesses",
            "title": "Benefits of TuttoGym",
            "subtitle": "Everything you need to stay active and healthy in one place",
            "descriptions": {
              "gyms": "Access more than 1,000 gyms with a single membership.",
              "activities": "Enjoy a wide variety of activities: yoga, swimming, padel, crossfit and more.",
              "businesses": "Companies trust us to offer wellness benefits to their employees."
            }
          },
          "search": {
            "title": "Find your ideal gym",
            "activities": "Activities",
            "plans": "Plans",
            "location": "City or postal code",
            "search": "Search",
            "searching": "Searching...",
            "noResults": "No gyms found matching your search."
          },
          "searchGyms": {
            "helmet": "Search Gyms | TuttoGym",
            "title": "Find Your Ideal Gym",
            "subtitle": "Filter by city, activities or postal code",
            "cityFilter": "City",
            "selectCity": "Select a city",
            "activitiesFilter": "Activities",
            "postalCodeFilter": "Postal Code",
            "enterPostalCode": "Enter a postal code",
            "searchButton": "Search",
            "noResults": "No gyms found matching your search",
            "tryDifferentSearch": "Try different filters or a different search"
          },
          "activities": {
            "all": "All",
            "padel": "Padel",
            "yoga": "Yoga",
            "swimming": "Swimming",
            "crossfit": "Crossfit",
            "fitness": "Fitness",
            "pilates": "Pilates",
            "boxing": "Boxing",
            "cycling": "Cycling",
            "spinning": "Spinning",
            "zumba": "Zumba",
            "gimnasio": "Gym",
            "aquagym": "Aquagym",
            "entrenamiento_personal": "Personal Training",
            "polideportivo": "Sports Center",
            "artes_marciales": "Martial Arts",
            "escalada": "Climbing"
          },
          "plans": {
            "bronze": "Bronze",
            "silver": "Silver",
            "gold": "Gold",
            "platinum": "Platinum",
            "diamond": "Diamond",
            "title": "Explore Our Plans",
            "subtitle": "Choose the plan that best suits your needs and goals",
            "features": {
              "gyms": "Gym access",
              "activities": "Included activities",
              "schedule": "Schedule",
              "guests": "Free guests",
              "trainer": "Personal trainer",
              "complete": "complete",
              "all": "all",
              "unlimited": "unlimited"
            },
            "monthly": "/month",
            "choosePlan": "Choose Plan",
            "mostPopular": "Most popular"
          },
          "footer": {
            "apps": "Apps",
            "social": "Social Media",
            "privacy": "Privacy",
            "cookies": "Cookies",
            "terms": "Terms",
            "security": "Security"
          },
          "faq": {
            "title": "Frequently Asked Questions",
            "subtitle": "Answers to the most common questions about TuttoGym",
            "questions": [
              {
                "question": "How does TuttoGym work?",
                "answer": "TuttoGym is a platform that allows you to access multiple gyms and activities with a single membership. Simply choose your plan, sign up, and start enjoying all the gyms and activities included in your membership."
              },
              {
                "question": "Can I cancel my subscription at any time?",
                "answer": "Yes, you can cancel your subscription at any time. There are no permanence contracts. The cancellation will be effective at the end of the current billing period."
              },
              {
                "question": "Is there any registration fee?",
                "answer": "No, we don't charge any registration fee. You only pay the monthly fee for the plan you choose."
              },
              {
                "question": "How many times can I visit the same gym?",
                "answer": "You can visit any gym in the network once per day. Please note that some gyms may set a maximum number of visits per month. This information will be specified in the gym's profile."
              },
              {
                "question": "How do I book an activity?",
                "answer": "You can book activities directly from our mobile app or website. Select the activity, schedule, and gym, and confirm your reservation with a few clicks."
              },
              {
                "question": "What if I can't attend a reserved activity?",
                "answer": "We ask you to cancel your reservation at least 2 hours in advance to free up space for other users. Frequent cancellations without prior notice may result in temporary restrictions on making reservations."
              }
            ]
          },
          "pages": {
            "business": {
              "benefits": [
                {
                  "title": "Improve your employees' health and well-being",
                  "description": "Offer access to more than 1,000 gyms and activities to promote a healthy lifestyle."
                },
                {
                  "title": "Reduce workplace absenteeism",
                  "description": "Active employees have 27% fewer sick days."
                },
                {
                  "title": "Increase productivity",
                  "description": "Regular exercise improves concentration and performance at work."
                },
                {
                  "title": "Attract and retain talent",
                  "description": "87% of employees consider wellness benefits when choosing an employer."
                }
              ],
              "features": [
                "Customized administration portal",
                "Usage and participation reports",
                "Dedicated business support",
                "Centralized billing",
                "Customization of plans according to needs",
                "Integration with HR systems",
                "Internal benefits communication",
                "Exclusive corporate events"
              ],
              "cta": {
                "title": "Ready to improve your team's well-being?",
                "subtitle": "Join more than 500 companies that already trust TuttoGym for their corporate wellness programs.",
                "button": "Contact an advisor"
              },
              "requestForm": {
                "title": "Request Information",
                "advisorTitle": "Contact an Advisor",
                "steps": ["Email", "Company", "Quote", "Additional Info", "Confirmation"],
                "emailStep": {
                  "title": "Enter your email",
                  "emailLabel": "Email",
                  "emailRequired": "Email is required",
                  "emailInvalid": "Invalid email format"
                },
                "companyStep": {
                  "title": "Company Information",
                  "companyNameLabel": "Gym Name",
                  "companyNameRequired": "Gym name is required",
                  "clientSizeLabel": "Number of Monthly Clients",
                  "clientSizeRequired": "Please select number of clients",
                  "avgPriceLabel": "Monthly Average Fee per Client",
                  "avgPriceRequired": "Please enter a valid average fee",
                  "phoneLabel": "Phone (optional)"
                },
                "quoteStep": {
                  "title": "Calculating your quote...",
                  "calculating": "Please wait while we calculate a personalized quote for your company...",
                  "quoteTitle": "Your Estimated Quote",
                  "quoteDescription": "This is an estimated annual price based on your company size.",
                  "downloadButton": "Download Quote",
                  "downloadSuccess": "Quote downloaded!"
                },
                "additionalInfoStep": {
                  "title": "Additional Information",
                  "subtitle": "Do you have any specific questions or requirements?",
                  "messageLabel": "Your message (optional)"
                },
                "confirmationStep": {
                  "title": "Thank You!",
                  "infoMessage": "We have received your information request. Our team will contact you shortly with more details.",
                  "advisorMessage": "Someone from ventas@tuttogym.com will contact you soon."
                },
                "buttons": {
                  "back": "Back",
                  "next": "Next",
                  "submit": "Submit",
                  "close": "Close"
                },
                "errors": {
                  "general": "An error occurred while processing your request. Please try again."
                }
              }
            },
            "individual": {
              "hero": {
                "title": "Your fitness journey starts here",
                "subtitle": "Access more than 1,000 gyms and activities with a single membership",
                "button": "Start now"
              },
              "benefits": [
                {
                  "title": "Freedom to choose",
                  "description": "Train wherever and whenever you want with access to more than 1,000 gyms."
                },
                {
                  "title": "Variety of activities",
                  "description": "From yoga to CrossFit, swimming to boxing - find what motivates you."
                },
                {
                  "title": "No commitments",
                  "description": "No long-term contracts. Cancel your membership whenever you want."
                },
                {
                  "title": "Affordable prices",
                  "description": "Plans starting at €29.99/month, much less than a traditional gym membership."
                }
              ],
              "features": {
                "title": "Why choose TuttoGym?",
                "subtitle": "The smart way to stay active",
                "items": [
                  "Access to more than 1,000 gyms",
                  "Book classes instantly",
                  "No registration fees",
                  "Bring friends with you",
                  "Personalized recommendations",
                  "24/7 customer support"
                ]
              },
              "testimonials": {
                "title": "What our members say",
                "items": [
                  {
                    "name": "Sarah Johnson",
                    "text": "TuttoGym has completely changed how I exercise. I love being able to try different activities and gyms depending on my mood and schedule."
                  },
                  {
                    "name": "Michael Rodriguez",
                    "text": "The flexibility is amazing. I travel a lot for work and can always find a gym nearby. It's like having a membership to every gym in the city!"
                  },
                  {
                    "name": "Emma Thompson",
                    "text": "I've discovered activities I never would have tried before. The variety keeps me motivated and I've never been in better shape."
                  }
                ]
              }
            },
            "partners": {
              "hero": {
                "title": "Grow your business with TuttoGym",
                "subtitle": "Join our network of gyms and fitness centers and reach thousands of new customers",
                "button": "Become a partner"
              },
              "benefits": [
                {
                  "title": "Increase your revenue",
                  "description": "Attract new customers and fill unused capacity without cannibalizing your existing membership base."
                },
                {
                  "title": "Zero risk",
                  "description": "No upfront costs or monthly fees. You only share revenue from the customers we bring to you."
                },
                {
                  "title": "Simple integration",
                  "description": "Our system integrates seamlessly with your existing management software and processes."
                },
                {
                  "title": "Full control",
                  "description": "You decide when TuttoGym members can visit your facility, maintaining control of your capacity."
                }
              ],
              "howItWorks": {
                "title": "How it works",
                "steps": [
                  {
                    "title": "Join our network",
                    "description": "Sign up as a TuttoGym partner and set up your profile with photos, amenities, and available activities."
                  },
                  {
                    "title": "Set your availability",
                    "description": "Define when TuttoGym members can visit your facility based on your capacity and peak hours."
                  },
                  {
                    "title": "Welcome new customers",
                    "description": "TuttoGym members check in using our app, and you verify their identity with a simple QR code scan."
                  },
                  {
                    "title": "Get paid",
                    "description": "Receive monthly payments for all TuttoGym visits to your facility, with detailed reporting and analytics."
                  }
                ]
              },
              "cta": {
                "title": "Ready to expand your customer base?",
                "subtitle": "Join over 1,000 fitness facilities already partnering with TuttoGym",
                "button": "Apply now"
              },
              "requestForm": {
                "title": "Request Information",
                "advisorTitle": "Contact an Advisor",
                "steps": ["Email", "Company", "Quote", "Additional Info", "Confirmation"],
                "emailStep": {
                  "title": "Enter your email",
                  "emailLabel": "Email",
                  "emailRequired": "Email is required",
                  "emailInvalid": "Invalid email format"
                },
                "companyStep": {
                  "title": "Company Information",
                  "companyNameLabel": "Gym Name",
                  "companyNameRequired": "Gym name is required",
                  "clientSizeLabel": "Number of Monthly Clients",
                  "clientSizeRequired": "Please select number of clients",
                  "avgPriceLabel": "Monthly Average Fee per Client",
                  "avgPriceRequired": "Please enter a valid average fee",
                  "phoneLabel": "Phone (optional)"
                },
                "quoteStep": {
                  "title": "Calculating your quote...",
                  "calculating": "Please wait while we calculate a personalized quote for your gym...",
                  "quoteTitle": "Your Estimated Quote",
                  "quoteDescription": "This is an estimated annual price based on your gym size.",
                  "downloadButton": "Download Quote",
                  "downloadSuccess": "Quote downloaded!"
                },
                "additionalInfoStep": {
                  "title": "Additional Information",
                  "subtitle": "Do you have any specific questions or requirements?",
                  "messageLabel": "Your message (optional)"
                },
                "confirmationStep": {
                  "title": "Thank You!",
                  "infoMessage": "We have received your partner request. Our team will contact you shortly with more details.",
                  "advisorMessage": "Someone from partners@tuttogym.com will contact you soon."
                },
                "buttons": {
                  "back": "Back",
                  "next": "Next",
                  "submit": "Submit",
                  "close": "Close"
                },
                "errors": {
                  "general": "An error occurred while processing your request. Please try again."
                }
              }
            },
            "plansAndPrices": {
              "title": "Plans and Prices",
              "subtitle": "Choose the plan that best suits your needs",
              "metaDescription": "Discover our plans and prices for individuals and businesses. Access thousands of gyms and activities with a single membership.",
              "tabs": {
                "individual": "Individual",
                "business": "Business"
              },
              "billing": {
                "monthly": "Monthly",
                "annual": "Annual",
                "saveText": "Save 20%"
              },
              "features": {
                "access100": "Access to 100+ gyms",
                "access500": "Access to 500+ gyms",
                "access800": "Access to 800+ gyms",
                "access1000": "Access to 1000+ gyms",
                "activities3": "3 included activities",
                "activities5": "5 included activities",
                "activitiesAll": "All activities included",
                "limitedHours": "Limited hours (8:00-16:00)",
                "fullHours": "Full hours",
                "poolAccess": "Pool access",
                "freeGuests": "Free guests",
                "freeGuests1": "1 free guest per month",
                "freeGuests2": "2 free guests per month",
                "personalTrainer": "Personal trainer",
                "personalTrainer1": "1 session with personal trainer",
                "personalTrainer2": "2 sessions with personal trainer"
              },
              "business": {
                "perUser": "/ user / month",
                "forUsers": "For {min}-{max} users",
                "forUsersUnlimited": "For {min}-∞ users",
                "customPrice": "Custom",
                "features": {
                  "access500": "Access to 500+ gyms",
                  "access800": "Access to 800+ gyms",
                  "access1000": "Access to 1000+ gyms",
                  "activities5": "5 included activities",
                  "activitiesAll": "All activities included",
                  "adminPanel": "Admin panel",
                  "advancedAdminPanel": "Advanced admin panel",
                  "customAdminPanel": "Custom admin panel",
                  "basicReports": "Basic reports",
                  "detailedReports": "Detailed reports",
                  "customReports": "Custom reports",
                  "emailSupport": "Email support",
                  "prioritySupport": "Priority support",
                  "dedicatedManager": "Dedicated account manager",
                  "corporateEvents": "Corporate events",
                  "corporateEvents2": "2 corporate events per year",
                  "corporateEventsUnlimited": "Unlimited corporate events"
                }
              },
              "buttons": {
                "choosePlan": "Choose Plan",
                "contact": "Contact Us"
              },
              "customPlan": {
                "title": "Need a custom plan?",
                "subtitle": "If you have specific needs or are looking for a tailored solution, contact our team.",
                "button": "Contact sales"
              },
              "companyPayment": {
                "title": "Want your company to pay 25%, 50% or 100% of your membership?",
                "button": "Click here"
              },
              "faq": {
                "title": "Frequently asked questions about plans and prices",
                "questions": [
                  {
                    "question": "Can I change my plan at any time?",
                    "answer": "Yes, you can upgrade or change your plan at any time. Changes will apply in your next billing cycle."
                  },
                  {
                    "question": "Is there a commitment period?",
                    "answer": "No, there is no commitment period. You can cancel your subscription at any time."
                  },
                  {
                    "question": "What payment methods do you accept?",
                    "answer": "We accept credit/debit cards (Visa, Mastercard, American Express) and PayPal. For business plans, we also offer bank transfer."
                  },
                  {
                    "question": "Do you offer student discounts?",
                    "answer": "Yes, we offer a 15% discount for students with valid identification. Contact our customer service for more information."
                  }
                ]
              },
              "dialog": {
                "title": {
                  "step1": "Request company sponsorship",
                  "step2": "Contact information"
                },
                "steps": {
                  "company": "Company information",
                  "contact": "Contact details"
                },
                "labels": {
                  "company": "Company name",
                  "email": "Company contact email"
                },
                "success": "Your request has been sent! Please send an email to ventas@tuttogym.com with the company information."
              }
            }
          },
          "signup": {
            "title": "Start your fitness journey",
            "closeButton": "Close",
            "backButton": "Back",
            "nextButton": "Next",
            "submitButton": "Submit",
            "processingButton": "Processing...",
            "steps": {
              "personalInfo": "Personal Information",
              "email": "Email",
              "sports": "Sports",
              "terms": "Terms & Policies",
              "confirmation": "Confirmation"
            },
            "validation": {
              "firstNameRequired": "First name is required",
              "lastNameRequired": "Last name is required",
              "emailRequired": "Email is required",
              "emailInvalid": "Invalid email format",
              "sportRequired": "Please select at least one sport or specify other sports",
              "termsRequired": "You must accept the terms and conditions",
              "privacyRequired": "You must accept the privacy policy"
            },
            "errors": {
              "general": "An error occurred while processing your request. Please try again."
            },
            "personalInfo": {
              "title": "Enter your personal information",
              "description": "We need this information to create your personal account.",
              "firstNameLabel": "First name",
              "lastNameLabel": "Last name"
            },
            "email": {
              "title": "Enter your email",
              "description": "We'll send you information about our services and how to get started.",
              "label": "Email"
            },
            "sports": {
              "title": "What sports do you practice?",
              "description": "Select all that apply. This helps us recommend the best gyms for you.",
              "otherSportsLabel": "Other sports (comma separated)",
              "otherSportsPlaceholder": "E.g. Climbing, Dancing, Volleyball"
            },
            "terms": {
              "title": "Terms and Policies",
              "description": "Please review and accept our terms and policies to continue.",
              "accept": "I accept the ",
              "name": "Terms and Conditions",
              "acceptMarketing": "I agree to receive commercial information and promotions from TuttoGym"
            },
            "confirmation": {
              "title": "Thank you!",
              "description": "We've received your information. TuttoGym will be launching on July 7, 2025, and we'll contact you before the launch with exclusive early access opportunities.",
              "emailSent": "A confirmation email has been sent to"
            },
            "privacy": {
              "accept": "I accept the ",
              "name": "Privacy Policy"
            }
          },
          "legal": {
            "terms": "Terms and Conditions",
            "privacy": "Privacy Policy",
            "contactForQuestions": "If you have any questions about this document, please contact us at",
            "lastUpdated": "Last updated",
            "termsIntroduction": "Introduction",
            "termsIntroductionText": "These terms and conditions govern the use of the service offered by TuttoGym on its website, mobile application and related platforms. By registering and using our services, you agree to be bound by these terms and conditions, as well as our Privacy Policy.",
            "servicesDescription": "Service description",
            "servicesDescriptionText": "TuttoGym offers a platform that allows users to access multiple gyms and sports activities through a subscription. Our service includes reservation management, access to different sports facilities and activities according to the contracted plan.",
            "accountRegistration": "Account registration and responsibilities",
            "accountRegistrationText": "To use our services, you must register and create an account. By doing so, you agree to provide true, accurate and complete information. You are responsible for maintaining the confidentiality of your account and password, as well as for all activities that occur under your account.",
            "subscriptionTerms": "Subscription terms and payments",
            "subscriptionTermsText": "TuttoGym offers different subscription plans. When contracting a plan, you agree to pay the corresponding fees. Payments are recurring and will be made automatically according to the selected billing cycle. You can cancel your subscription at any time, which will be effective at the end of the current billing period.",
            "useRestrictions": "Use restrictions",
            "useRestrictionsText": "Access to facilities and activities is subject to availability and the specific terms of each gym or center. TuttoGym reserves the right to restrict access in case of misuse or non-compliance with established rules.",
            "intellectualProperty": "Intellectual property",
            "intellectualPropertyText": "All content on our website and application, including text, graphics, logos, icons, images and software, is the property of TuttoGym or its suppliers and is protected by intellectual property laws.",
            "liability": "Limitation of liability",
            "liabilityText": "TuttoGym is not responsible for injuries or damages that may occur during sports activities. Users participate at their own risk and must follow the safety instructions and rules of each facility.",
            "termsModification": "Modification of terms",
            "termsModificationText": "TuttoGym reserves the right to modify these terms and conditions at any time. The modifications will take effect immediately after their publication. Continued use of our services after any change constitutes your acceptance of the new terms.",
            "terminationOfService": "Termination of service",
            "terminationOfServiceText": "TuttoGym reserves the right to suspend or terminate your account and access to services in case of non-compliance with these terms and conditions, fraudulent use or any activity that may harm the platform or other users.",
            "applicableLaw": "Applicable law",
            "applicableLawText": "These terms and conditions are governed by the laws of Spain. Any dispute related to these terms will be resolved in the competent courts of Barcelona.",
            "privacyIntroduction": "Introduction",
            "privacyIntroductionText": "At TuttoGym we take the privacy of our users very seriously. This Privacy Policy describes how we collect, use, process and protect your personal information when you use our services, whether through our website, mobile application or other platforms.",
            "dataCollection": "Information we collect",
            "dataCollectionText": "We may collect the following personal information:",
            "dataCollection1": "Registration information: name, surname, email address, password.",
            "dataCollection2": "Profile information: age, gender, sports interests, profile picture (optional).",
            "dataCollection3": "Billing data: payment information, transaction history.",
            "dataCollection4": "Usage data: information about how you use our services, gyms you visit, activities you book.",
            "dataCollection5": "Technical information: IP address, browser type, device, operating system.",
            "dataUse": "How we use your information",
            "dataUseText": "We use the collected information to:",
            "dataUse1": "Provide, maintain and improve our services.",
            "dataUse2": "Process payments and manage your subscription.",
            "dataUse3": "Personalize your experience and provide you with recommendations.",
            "dataUse4": "Communicate with you about updates, offers and events.",
            "dataUse5": "Detect, prevent and address technical issues, fraud or illegal activities.",
            "dataSharing": "Data sharing",
            "dataSharingText": "We may share your information with:",
            "dataSharing1": "Associated gyms and sports centers to validate your access and reservations.",
            "dataSharing2": "Service providers that help us provide our services (payment processing, analytics, marketing).",
            "dataSharing3": "Legal authorities when required by law or to protect our rights.",
            "dataSecurity": "Data security",
            "dataSecurityText": "We implement technical, administrative and physical security measures designed to protect the personal information we collect. However, no system is completely secure, so we cannot guarantee the absolute security of your information.",
            "dataRetention": "Data retention",
            "dataRetentionText": "We retain your personal information while you maintain an active account or as necessary to provide you with services. We may also retain certain information to comply with legal obligations, resolve disputes and enforce our agreements.",
            "yourRights": "Your rights",
            "yourRightsText": "Depending on your location, you may have certain rights related to your personal information, including:",
            "yourRights1": "Access your personal information.",
            "yourRights2": "Correct inaccurate information.",
            "yourRights3": "Delete your information in certain circumstances.",
            "yourRights4": "Object to the processing of your information.",
            "yourRights5": "Withdraw your consent at any time.",
            "cookies": "Cookies and similar technologies",
            "cookiesText": "We use cookies and similar technologies to improve your experience, analyze traffic and personalize content. You can manage your cookie preferences through your browser settings.",
            "privacyChildren": "Children's privacy",
            "privacyChildrenText": "Our services are not directed at persons under 16 years of age. We do not knowingly collect personal information from children under 16 years of age. If we discover that we have collected personal information from a child under 16 years of age, we will delete that information as soon as possible.",
            "privacyChanges": "Changes to this Privacy Policy",
            "privacyChangesText": "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and, if the changes are significant, we will provide you with a more prominent notice or send you an email notification."
          },
          "dashboard": {
            "customer": {
              "title": "Customer Dashboard",
              "id": "Customer ID",
              "welcome": "Welcome",
              "welcomeText": "This is your personal TuttoGym dashboard. Here you can track your fitness activities, manage your memberships, and view your progress.",
              "myFitnessCenters": "My Fitness Centers",
              "myActivities": "My Activities",
              "activitiesThisMonth": "Activities This Month",
              "activeMemberships": "Active Memberships"
            },
            "memberSince": "Member since",
            "history": "History",
            "statistics": "Statistics",
            "tabs": {
              "dashboard": "Dashboard",
              "activity": "Activity",
              "settings": "Settings"
            }
          }
        }
      }
    }
  });

export default i18n; 